module.exports = __webpack_public_path__ + "media/images/error-notice-0afe109acaa3daff23eacaadb535a53a.svg";